import React from 'react';
export function SectionFullWidth(props) {
    const { backgroundColor, children, cssClass } = props;
    return (React.createElement("table", { align: "center", className: cssClass, border: "0", cellPadding: "0", cellSpacing: "0", role: "presentation", style: {
            background: backgroundColor,
            // eslint-disable-next-line object-shorthand
            backgroundColor: backgroundColor,
            width: '100%',
        } },
        React.createElement("tbody", null,
            React.createElement("tr", null,
                React.createElement("td", null, children)))));
}
//# sourceMappingURL=section-full-width.js.map